/*
 * @Author: Zhouqi
 * @Date: 2025-11-04 15:39:57
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-11-05 14:35:17
 */
import { Tabs, TabsProps } from 'antd';

import styles from './index.module.scss';

type JustifyDirection = 'center' | 'left' | 'right';

export interface OperationTabProps extends TabsProps {
  justifyDirection?: JustifyDirection;
}

const OperationTabs: React.FC<OperationTabProps> = (props) => {
  const { className, justifyDirection = 'center', ...restProps } = props;
  const justifyDirectionClass = styles[justifyDirection] || '';

  return (
    <div
      className={`
        ${styles.operationTabContainer} 
        ${justifyDirectionClass} 
        ${className || ''}
      `}
    >
      <Tabs className="h-full" more={undefined} {...restProps}></Tabs>
    </div>
  );
};

export default OperationTabs;
